import { UIField } from "../../../models/UIField";

export const NumberField = ({ model, float }: { model: UIField; float?: boolean }) => {
  const s = model.readonly ? "addProductReadonlyField" : "addProductField";

  return <input type="number" className={`${s} text-right`} disabled={model.disabled} readOnly={model.readonly} step={float ? 0.01 : 1} min={float ? 0.0 : 1} value={model.value} onChange={(e) => model.setValue(parseFloat(e.target.value))} />;
};
